export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'f7977c10-a706-46cf-a210-b329aa785a42',
      authority: 'https://login.microsoftonline.com/a5711206-1554-4bae-9101-7208e77b3114',
    },
  },
  apiConfig: {
    scopes: ['api://c98f7278-4654-4552-8b18-2c2f0bc5bce2/access_as_user'],
    uri: 'https://apim-dev.keolis.com/smartplanner/api',
    subscriptionKey: '2d17f9bf955c4e11b8ee94ac8ac09d42',
  },
};
